
import classStatisticsBar         from '../../shared/class-statistics-bar';
import InfiniteCarousel           from '../../shared/InfiniteCarousel';
import videoModal                 from '../../shared/video-modal';
import UrlHelper                  from '_utils/UrlHelper';


let certifiedClass, classStatistics, carouselInfiniteContainer, band2Carousel, classDescriptionChildElements, classDescription, classDescriptionReadMoreBtn, watchVideoButton, flashcardDropdown, MARKETING_TEXT_PREVIEW;

const certifiedClassPage = {

  init: function () {

    /*
    ==================================================
      CACHE DOM ELEMENTS
    ==================================================
    */

    certifiedClass = document.querySelector('.certified-class-page');

    if (certifiedClass) {
      classStatistics = certifiedClass.querySelector('.band-2 .class-statistics-items');
      carouselInfiniteContainer = certifiedClass.querySelector('.band-2 .carousel-infinite');
      classDescription = certifiedClass.querySelector('.band-3 .rich-marketing-text');
      classDescriptionChildElements = classDescription.children;
      classDescriptionReadMoreBtn = certifiedClass.querySelector('.band-3 .text-button');
      watchVideoButton = certifiedClass.querySelector('.band-3 .watch-video-button');
      flashcardDropdown = certifiedClass.querySelectorAll('.band-4 .flashcard-dropdown-container .flashcard-dropdown');
      MARKETING_TEXT_PREVIEW = 3;
    }

    /*
    ======================================================
    INIT BAR CAROUSEL
    ======================================================
    */

    if (carouselInfiniteContainer && carouselInfiniteContainer.querySelectorAll('.carousel-infinite-slide').length > 1) {
      band2Carousel = new InfiniteCarousel;

      band2Carousel.init({
        carouselContainer: carouselInfiniteContainer,
        autoPlay: true,
        indicatorDots: false,
        pausePlay: false,
        lazyLoad: false,
        interval: 5000,
        pausePlaySpaceBar: true
      });
    }

    /*
    ==================================================
      WIRE BEHAVIORS
    ==================================================
    */

    if (classStatistics) {
      this.handleCountersObserver();
    }

    if (classDescription) {
      let hyperLinks = certifiedClass.querySelectorAll('.band-3 .rich-marketing-text a[href*="http"]');
      this.handleMarketingTextDisplay();

      if (hyperLinks) {
        this.handleLinksTarget(hyperLinks);
      }
    }

    if (classDescriptionChildElements) {
      this.handleClassDescriptionChildElementsObserver();
    }

    if (classDescriptionReadMoreBtn) {
      this.handleMarketingTextButtonDisplay();
    }

    if (watchVideoButton) {
      let videoUrl = watchVideoButton.getAttribute('data-video-url') || null;

      watchVideoButton.addEventListener('click', () => {
        this.handleOpenVideoModalRequest(videoUrl);
      });
    }

    if (flashcardDropdown.length > 1) {
      this.handleFlashcardsDropdownClick();
    }
  },


  /*
  ==================================================
    EVENT HANDLERS
  ==================================================
   */

  handleCountersObserver() {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          classStatisticsBar.init();
          observer.unobserve(classStatistics.querySelector('.decks'));
        }
      });
    });

    observer.observe(classStatistics.querySelector('.decks'));
  },

  handleMarketingTextDisplay() {
    this.displayPreviewMarketingText();
  },

  handleClassDescriptionChildElementsObserver() {
    let callback = function (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
          entry.target.classList.add('animated');
        } else {
          entry.target.classList.remove('animated');
        }
      });
    }

    let observer = new IntersectionObserver(callback);

    Array.from(classDescriptionChildElements).forEach(function (childElement) {
      observer.observe(childElement);
    });
  },

  handleMarketingTextButtonDisplay() {
    if (classDescriptionChildElements.length > MARKETING_TEXT_PREVIEW) {
      classDescriptionReadMoreBtn.classList.remove('hidden');
      classDescriptionReadMoreBtn.addEventListener('click', () => {
        this.handleMarketingTextReadMoreClick();
      });
    }
  },

  handleMarketingTextReadMoreClick() {
    const isOpen = classDescriptionReadMoreBtn.classList.toggle('open');
    isOpen ? this.displayFullMarketingText() : this.resetScrollPosition();
    this.marketingTextBtnText(isOpen);
  },

  handleLinksTarget(links) {
    let getBaseUrl = elem => elem.protocol + "//" + elem.host;
  
    links.forEach((link) => {
      if (getBaseUrl(link) != getBaseUrl(window.location)) {
        link.setAttribute("target", "_blank");
      }
    });
  },

  handleCloseVideoModalRequest() {
    this.toggleVideoModal(false);
  },

  handleOpenVideoModalRequest(videoUrl) {
    if (videoUrl) {
      const videoProps = UrlHelper.parseYouTubeUrl(videoUrl);

      if (videoProps.isValidUrl && videoProps.type == 'embed') {
        this.toggleVideoModal(true, videoProps.url);
      }
    }
  },

  handleClickedFlashcardDropdown(element) {
    element.parentElement.classList.toggle('is-open');
  },

  handleNonClickedFlashcardDropdown() {
    let dropdowns = certifiedClass.querySelectorAll('.band-4 .flashcard-dropdown-container.is-open');

    dropdowns.forEach((dropdown) => {
      dropdown.classList.remove('is-open');
    });
  },

  handleFlashcardsDropdownClick() {
    flashcardDropdown.forEach((element) => {
      element.addEventListener('click', () => {
        if (!element.parentElement.classList.contains('is-open')) {
          this.handleNonClickedFlashcardDropdown();
        }
        this.handleClickedFlashcardDropdown(element);
      });
    });
  },

  /*
  ==================================================
    LOCAL UTILS
  ==================================================
  */

  displayFullMarketingText() {
    Array.from(classDescriptionChildElements).forEach(function (item) {
      item.style.display = 'block';
    });
  },

  displayPreviewMarketingText() {
    Array.from(classDescriptionChildElements).forEach(function (item, index) {
      (index < MARKETING_TEXT_PREVIEW) ? item.style.display = 'block' : item.style.display = 'none';
    });
  },

  marketingTextBtnText(value) {
    let fullMarketingTextIsOpen = value;
    let result = (fullMarketingTextIsOpen) ? classDescriptionReadMoreBtn.innerHTML = 'Collapse' : classDescriptionReadMoreBtn.innerHTML = 'Read more';
    return result;
  },

  resetScrollPosition() {
    const navbarHeight = document.querySelector('.navbar').offsetHeight;
    const targetElement = certifiedClass.querySelector('.band.band-3');
    const scrollPosition = targetElement.getBoundingClientRect().top + window.scrollY - navbarHeight - 72;
  
    window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    setTimeout(() => this.displayPreviewMarketingText() || this.marketingTextBtnText(false), 1000);
  },  

  toggleVideoModal(isOpen = false, videoUrl = null) {
    videoModal.render({
      isOpen: isOpen,
      onCloseRequest: () => this.handleCloseVideoModalRequest(),
      selector: '.modals',
      shouldAutoPlay: true,
      videoUrl: videoUrl,
    });
  },
};

export default certifiedClassPage;